import { render, staticRenderFns } from "./ChoosePermission.vue?vue&type=template&id=b0841a74&scoped=true&"
import script from "./ChoosePermission.vue?vue&type=script&lang=js&"
export * from "./ChoosePermission.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePermission.vue?vue&type=style&index=0&id=b0841a74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0841a74",
  null
  
)

export default component.exports